import { render } from "./role-selection.vue?vue&type=template&id=cf7e1cc8&lang=pug"
import script from "./role-selection.vue?vue&type=script&setup=true&lang=js"
export * from "./role-selection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__